import React from "react";

const STATUS_STYLES = {
  "Looking": "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Passive": "bg-amber-100 text-amber-700 border-amber-200",
  "Not Looking": "bg-red-100 text-red-700 border-red-200",
  "Placed": "bg-slate-100 text-slate-600 border-slate-200",
  "Follow Up Later": "bg-indigo-100 text-indigo-700 border-indigo-200",
};

export default function StatusBadge({ status, className = "" }) {
  const cls = STATUS_STYLES[status] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span
      data-testid={`status-badge-${(status || "unknown").toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full border ${cls} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${status === "Looking" ? "bg-emerald-500" : status === "Passive" ? "bg-amber-500" : status === "Not Looking" ? "bg-red-500" : status === "Placed" ? "bg-slate-400" : "bg-indigo-500"}`} />
      {status || "—"}
    </span>
  );
}
